<template>
  <component :is="mainTemplate" :full="true">
    <template #navigation>
      <DisplaySection gap="xl" tag="nav">
        <NavigationButtonBack
          v-if="!profile.needToDefineMainContent"
          :label="buttonBackLabel"
          :url="buttonBackUrl"
        />
      </DisplaySection>
    </template>
    <TemplateSectionWithHeader>
      <template #header>
        <DisplaySection>
          <LbBannerNomad
            v-if="!profile.needToDefineMainContent && !profile.isASubscriber"
            class="banner"
          />
          <header v-if="profile.needToDefineMainContent">
            <heading tag="h1" icon="library">
              {{ library.title }}
            </heading>
            <p>{{ library.freeLibraryDescription }}</p>
          </header>
          <h1 v-else-if="profile.isASubscriber">
            <strong>Nomad+</strong>, L'abonnement premium pour cartonner !
          </h1>
        </DisplaySection>
      </template>
      <DisplaySection>
        <LbViewRouter />
      </DisplaySection>
    </TemplateSectionWithHeader>
  </component>
</template>
<script lang="ts" setup>
const profile = useProfileStore();

const route = useRoute();

const { greaterOrEqual } = useEvaBreakpoints();

const isAboveL = greaterOrEqual('l');

const { libraryManager } = inject(INJECT_LIBRARY_PAGE_OR_FORM);

const { t } = useI18n();

const { library, libraryBook, links } = libraryManager;

if (library.value) useAppEventLibraryBox(library.value);

const isIndex = computed(() => route.path === '/nomad');

if (isIndex.value && library?.value?.id) {
  useAppEventView(EventView.NomadPlus, library.value.id);
}

useWebsiteHead({
  title: isIndex.value
    ? `Nomad+ - ${t('title.nomadplus')}`
    : `Nomad+ - ${library?.value?.title || libraryBook?.value?.metaTitle}`,
});

const buttonBackLabel = computed(() =>
  profile.isParent ? 'Pour vous' : 'Mes révisions'
);

const buttonBackUrl = computed(() =>
  profile.isParent ? '/pour-vous' : '/revisions'
);

const mainTemplate = computed(() => {
  if (!profile.needToDefineMainContent) {
    return resolveComponent('TemplateContentSubNav');
  }
  return resolveComponent('TemplateContentSingle');
});
</script>
<style lang="scss" scoped>
.banner {
  display: flex;
}

.subsection {
  .banner {
    @include above('l') {
      display: none;
    }
  }
}
</style>
